import { render, staticRenderFns } from "./ButtonGroupComponent.vue?vue&type=template&id=2284affe&"
import script from "./ButtonGroupComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports